import type { PropsWithChildren } from "react";

export default function CheckoutContainer({ children }: PropsWithChildren) {
  return (
    <section className="relative flex flex-1 flex-col divide-y border-b border-grey-150 md:pb-12">
      {children}
    </section>
  );
}
